<template>
  <div
    class="h-full rounded-lg flex flex-col gap-2"
    style="position: relative"
  >
    <div
      class="h-full flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema"
    >
      <div class="flex flex-col md:flex-row gap-2 flex-shrink-0 overflow-hidden">
        <AppTabelaPrecoForm
          :show="show_form"
          :disable_visibility="true"
          :update_visibility="true"
          :form_title="form_title"
          :form_data="tabela_preco_formData"
          :create_btn="create_btn"
          :set_data="tabela_preco_setData"
          @close="closeForm"
          @show_table="show_form_table"
          @create="create_tabela_preco"
          @update="update_tabela_preco"
          @disable="disable_precario"
        />

        <ItemPrecarioDataTable 
          ref="itemPrecarioTable"
          :show="show_item_precario_table"
          :visibility="true"
          :table-title="generic_table_title"
          :search-by="searchBy"
          :tabela-preco="tabelaPreco"
          :show-export="true"
          :show-filters="true"
          :show-actions="true"
          :show-close-btn="true"
          @row-click="handleRowClick"
          @edit="handleEditItemPrecario"
          @bulk-edit="handleBulkEditItemPrecario"
          @selection-changed="handleSelectionChanged"
          @delete="handleDeleteItemPrecario"
          @filters-changed="handleFiltersChanged"
          @close="close_generic_table"
        />

        <AppMultiTable
          v-if="show_multiTable"
          title="Adicionar Locais de Instalação"
          :table1="{
            title: 'Instalações com tabela de preço',
            type: 'tabelaPrecos',
            owner: {
              id: tabelaPreco.id,
              nome: 'tabelapreco_id',
            },

            rotas: {
              select_all_url: `${baseURl}/api/v1/precario/${tabelaPreco.id}/?localinstalacao_only=true/`,
              create_url: `${baseURl}/api/v1/localinstalacao/registrar/`,
              select_url: `${baseURl}/api/v1/localinstalacao/`,
              update_url: `${baseURl}/api/v1/localinstalacao/editar`,
              delete_url: `${baseURl}/api/v1/localinstalacao/eliminar`,
            },
          }"
          :table2="{
            title: 'Instalações',
            type: 'tabelaPrecos',
            rotas: {
              select_all_url: `${baseURl}/api/v1/localinstalacao/?short_response=true`,
              create_url: '',
              select_url: '',
              update_url: '',
              delete_url: '',
            },
          }"
          @close="close_multiTable()"
        />
      </div>
      <div class="w-full">
        <!-- <PopupPainel :loading="false" :message="'Fora de Serviço...'" :bg="true" :outService="true" :textColor="red" /> -->

        <!-- Generic Table -->
        <GenericDataTable
          v-if="validPermission('B0006')"
          ref="dataTableRef"
          @row-click="select_tabela_preco"
          :tableData="tabelaPrecos"
          :useServerSide="false"
          :columns="precarioColumns"
          :show_export="true"
          :show_close_btn="false"
          table_title="Precários"
        >
          <template #left-actions>
            <button
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'create_tabelaPreco' })"
              title="Adicionar"
            >
              <i class="fa-solid fa-circle-plus fa-xl"></i>
            </button>
          </template>
        </GenericDataTable>
      </div>
      <ItemPrecarioEditPopUp
        v-if="show_item_precario_edit"
        :show="show_item_precario_edit"
        :itemData="item_precario_data"
        :currentCurrency="tabelaPreco.tpMoeda_nome || 'EUR'"
        :currentCurrencySymbol="tabelaPreco.tpMoeda_simbolo || '€'"
        @close="close_item_precario_edit"
        @saved="handleItemPrecarioSaved"
      />

      <ItemPrecarioBulkEditPopUp
        v-if="show_bulk_edit"
        :show="show_bulk_edit"
        :selectedItems="bulk_edit_items"
        :currentCurrency="tabelaPreco.tpMoeda_nome || 'EUR'"
        :currentCurrencySymbol="tabelaPreco.tpMoeda_simbolo || '€'"
        :currentFilters="current_filters"
        :isBaseTable="is_base_table"
        @close="closeBulkEdit"
        @apply-changes="handleBulkChangesApply"
      />

      <!-- Dependency Confirmation Popup -->
      <MyConfirmPopUp
        ref="dependencyConfirm"
        :message="dependencyConfirmMessage"
        @accept="handleDependencyConfirmAccept"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import AppInfoCard from "@/components/infoCard.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppButton from "@/components/updated/button.vue";
import AppForm from "@/components/form.vue";
// import AppTabelaPrecoForm from '@/components/updated/tabelaPrecoForm.vue'
import AppTabelaPrecoForm from "@/components/tables/tabelaPrecoForm.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppFilterForm from "@/components/filter/filterForm.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import AppGenericCrud from "@/components/genericCRUD_tabelaPreco.vue";
import { toast } from "vue3-toastify";

import PopupPainel from "@/components/_popupPainel.vue";
import permissionMixin from "@/permissionMixin.js";

import AppMultiTable from "@/components/multiTable.vue";
import ItemPrecarioDataTable from "@/components/dataTable/ItemPrecarioDataTable.vue";
import ItemPrecarioEditPopUp from "@/components/popUps/itemPrecarioEditPopUp.vue";
import ItemPrecarioBulkEditPopUp from "@/components/popUps/ItemPrecarioBulkEditPopUp.vue";
import MyConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import { useFormValues } from "vee-validate";

export default {
  mixins: [permissionMixin],
  name: "appTabelaPreco",
  components: {
    AppGenericCrud,
    AppTable,
    AppInfoCard,
    AppForm,
    AppFilter,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppTabelaPrecoForm,
    AppButton,
    AppFilterForm,
    PopupPainel,
    AppMultiTable,
    ItemPrecarioDataTable,
    ItemPrecarioEditPopUp,
    ItemPrecarioBulkEditPopUp,
    MyConfirmPopUp,
    GenericDataTable,
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      tabelaPrecos: [],
      tabelaPreco: {},

      equipamentos: [],
      artigos: [],

      armazens: [],

      generic_table_data: [],

      generic_table_title: "Generic Table",
      current_table: "none",

      show_form: false,
      show_table: true,
      show_action_card: true,
      show_generic_table: false,
      show_calendar: false,
      show_crud: false,
      show_multiTable: false,
      hiddenHeaders: ["id", "tpMoeda_id", "familia_id"],

      form_title: "No Title",
      create_tabela_preco_: false,
      tabela_preco_formData: {},
      tabela_preco_setData: {},

      show_item_precario_edit: false,
      item_precario_data: {},

      // Bulk Edit properties
      show_bulk_edit: false,
      bulk_edit_items: [],
      current_filters: {},

      // Dependency Confirmation properties
      dependencyConfirmMessage: "",
      pendingDependencyData: null,

      //   FilterForm data
      show_form_filter: false,
      selectedFiltro: "",
      filtroOptions: [],
      tabela: "tabelaPreco",
      table_title: "Tabela de Preços",
      productList: [],
      marcaList: [],
      familiaList: [],
      serviceList: [],
      itemPrecoGeralList: [],
      show_item_precario_table: false,
      create_btn: false,
      refresh: false,
      filtroData: {},
      searchBy: "",
      order_by: "",
      page_size: 10,

      precarioColumns: [
        {
          key: "versao",
          label: "Versão",
          type: "number",
          maxWidth: 100
        },
        {
          key: "nome",
          label: "Nome",
          type: "string",
          maxWidth: 150
        },
        {
          key: "data",
          label: "Data",
          type: "date",
          maxWidth: 100
        },
        {
          key: "validade",
          label: "Validade",
          type: "date",
          maxWidth: 100
        },
        {
          key: "tabela_base",
          label: "Tabela Base",
          type: "boolean",
          maxWidth: 150
        },
        {
          key: "status",
          label: "Status",
          type: "badge",
          maxWidth: 100
        },
      ],
    };
  },

  created() {
    this.get_tabelaPrecos();
    this.setTabelaPrecoForm(null);
  },

  methods: {
    handleItemPrecarioSaved(updatedItem) {
      this.close_item_precario_edit();

      // Refresh the ItemPrecarioDataTable
      if (this.$refs.itemPrecarioTable) {
        this.$refs.itemPrecarioTable.refresh();
      }

      toast.success("Item atualizado com sucesso", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    },

    close_item_precario_edit() {
      this.show_item_precario_edit = false;
      this.item_precario_data = {};
      this.refresh = true; // Trigger table refresh
    },

    // Bulk Edit Methods
    openBulkEdit(selectedItems) {
      this.bulk_edit_items = selectedItems;
      this.show_bulk_edit = true;
    },

    closeBulkEdit() {
      this.show_bulk_edit = false;
      this.bulk_edit_items = [];
    },

    handleSelectionChanged(selectedItems) {
      // Store selected items for potential bulk operations
      this.bulk_edit_items = selectedItems;
    },

    async handleBulkChangesApply(changes) {
      try {
        // Apply the bulk changes through API
        const requestData = {
          items: this.bulk_edit_items.map((item) => item.id),
          changes: changes,
          tabela_id: this.tabelaPreco.id,
          apply_to_other_tables: changes.applyToOtherTables || false,
        };

        const response = await axios.post(
          `${this.baseURl}/api/v1/bulk-update-item-precario/`,
          requestData
        );

        if (response.status === 200) {
          this.closeBulkEdit();

          // Refresh the table
          if (this.$refs.itemPrecarioTable) {
            this.$refs.itemPrecarioTable.refresh();
          }

          const updatedCount =
            response.data.data?.updated_count || this.bulk_edit_items.length;
          const tablesAffected = response.data.data?.tables_affected || 1;

          let successMessage = `${updatedCount} itens atualizados com sucesso`;
          if (changes.applyToOtherTables && tablesAffected > 1) {
            successMessage += ` em ${tablesAffected} tabela(s) de preço`;
          }

          toast.success(successMessage, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error("Error applying bulk changes:", error);
        let errorMessage = "Erro ao aplicar alterações em lote";

        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        }

        toast.error(errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
      }
    },

    handleRowClick(row) {
      console.log("Row clicked:", row);
      // You can add more actions here based on your requirements
    },
    validateForm() {
      if (!this.crud.crud_model.nome) {
        alert("Nome é obrigatório");
        return false;
      }
      return true;
    },

    async getProdutos() {
      await axios.get(`${this.baseURl}/api/v1/produto/`).then((res) => {
        this.produtos = res.data.data.sort((a, b) => a.id - b.id);
        this.produtoList = this.produtos.map(
          ({ foto, familia_id, ...rest }) => rest
        );
      });
    },

    async getMarcas() {
      await axios.get(`${this.baseURl}/api/v1/tpmarca/`).then((res) => {
        this.marcaList = res.data.data.sort((a, b) => a.id - b.id);
        // this.marcas = this.marcas.map(({ foto, familia_id, ...rest }) => rest);
      });
    },

    async getItemPrecoGeral() {
      await axios
        .get(
          `${this.baseURl}/api/v1/itemprecario/?campo=precario_id&&valor=${this.tabelaPreco.id}&&exact=1`
        )
        .then((res) => {
          const data = res.data.data.map((item) => {
            return {
              id: item.id,
              equipamento: item.equipamento_nome,
              venda: item.venda,
              vendaMin: item.vendaMin,
              compraMin: item.compraMin,
              compraMed: item.compraMed,
              compraAtual: item.compraAtual,
            };
          });
          this.itemPrecoGeralList = data.sort((a, b) => a.id - b.id);

          // this.familiaList = this.produtos.map(({ foto, familia_id, ...rest }) => rest);
        });
    },

    async getFamilia() {
      await axios.get(`${this.baseURl}/api/v1/familia/`).then((res) => {
        this.familiaList = res.data.data.sort((a, b) => a.id - b.id);
        // this.familiaList = this.produtos.map(({ foto, familia_id, ...rest }) => rest);
      });
    },

    async update_tabela_preco(data) {
      let update_data = this.setData(data);

      const res = await this.update(
        `${this.baseURl}/api/v1/precario/editar/${data.id}/`,
        update_data
      );
      if (res) {
        this.closeForm();
        toast.success("Tabela de Preço atualizada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.get_tabelaPrecos();
        this.show_table = true;
      } else {
        toast.error("Erro ao atualizar a tabela de Preço", {
          autoClose: 1000,
        });
      }
    },

    async disable_precario(data, forceDeactivate = false) {
      try {
        let url;
        let successText;

        if (data.status === "ativo") {
          // If current status is active, we want to activate it
          url = `${this.baseURl}/api/v1/precario/eliminar/${data.id}/?ativar`;
          successText = "ativada";
        } else {
          // If current status is not active, we want to deactivate it (default behavior)
          url = `${this.baseURl}/api/v1/precario/eliminar/${data.id}/`;
          if (forceDeactivate) {
            url += "?force=true";
          }
          successText = "desativada";
        }

        const response = await axios.delete(url);

        if (response.status === 200) {
          this.closeForm();
          toast.success(`Tabela de Preço ${successText} com sucesso`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          await this.get_tabelaPrecos();
          this.show_table = true;
        }
      } catch (error) {
        console.error("Error in disable_precario:", error);

        // Check if it's a dependency conflict (HTTP 409)
        if (error.response && error.response.status === 409) {
          const dependencyData = error.response.data.data;
          const message = error.response.data.message;

          this.showDependencyConfirmation(data, dependencyData, message);
        } else if (error.response && error.response.status === 400) {
          // Base table protection
          toast.error(error.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else {
          toast.error("Erro ao processar a operação", {
            autoClose: 1000,
          });
        }
      }
    },

    showDependencyConfirmation(data, dependencies, message) {
      console.log("Dependencies received:", dependencies);

      // Fix: access the nested dependencies object
      const dependencyData = dependencies.dependencies || {};
      const localInstalacoes = dependencyData.local_instalacoes || [];
      const contratos = dependencyData.contratos || [];

      console.log("Local instalacoes count:", localInstalacoes.length);
      console.log("Local instalacoes data:", localInstalacoes);

      // Create a simpler, more readable message for the popup
      let detailMessage = message + " ";

      const MAX_NAMES_TO_SHOW = 5; // Limit to prevent too long messages

      if (localInstalacoes.length > 0) {
        const localNames = localInstalacoes
          .slice(0, MAX_NAMES_TO_SHOW)
          .map((item) => item.nome);
        let localText = localNames.join(", ");

        if (localInstalacoes.length > MAX_NAMES_TO_SHOW) {
          const remaining = localInstalacoes.length - MAX_NAMES_TO_SHOW;
          localText += ` e mais ${remaining} local(is)`;
        }

        console.log("Local names:", localText);
        detailMessage += `Locais: ${localText}. `;
      }

      if (contratos.length > 0) {
        const contratoNames = contratos
          .slice(0, MAX_NAMES_TO_SHOW)
          .map((item) => item.nome || `ID: ${item.id}`);
        let contratoText = contratoNames.join(", ");

        if (contratos.length > MAX_NAMES_TO_SHOW) {
          const remaining = contratos.length - MAX_NAMES_TO_SHOW;
          contratoText += ` e mais ${remaining} contrato(s)`;
        }

        detailMessage += `Contratos: ${contratoText}. `;
      }

      detailMessage += "As referências serão removidas. Continuar?";

      console.log("Final message:", detailMessage);

      // Store the data for the confirm handler
      this.pendingDependencyData = data;

      // Fix timing issue: Set message first, then show popup with a small delay
      this.dependencyConfirmMessage = detailMessage;

      // Use nextTick to ensure the message is set before showing the popup
      this.$nextTick(() => {
        this.$refs.dependencyConfirm.show();
      });
    },

    handleDependencyConfirmAccept() {
      if (this.pendingDependencyData) {
        this.disable_precario(this.pendingDependencyData, true); // Force deactivate
        this.pendingDependencyData = null;
        this.dependencyConfirmMessage = "";
      }
    },

    setTabelaPrecoForm(data) {
      this.tabela_preco_formData = {
        id: data && data.id ? data.id : 0,
        nome: data && data.nome ? data.nome : "",
        versao: data && data.versao ? data.versao : "",
        validade: data && data.validade ? data.validade : "",
        data: data && data.data ? data.data : "",
        descontoBase: data && data.descontoBase ? data.descontoBase : "",
        descontoMax: data && data.descontoMax ? data.descontoMax : "",
        valorRapel: data && data.valorRapel ? data.valorRapel : "",
        descontoRapel: data && data.descontoRapel ? data.descontoRapel : "",
        tpMoeda_id: data && data.tpMoeda_id ? data.tpMoeda_id : "",
        tabela_base: data && data.tabela_base ? data.tabela_base : 0,
        status: data && data.status ? data.status : "desativo",
      };
    },

    close_crud() {
      if (this.show_crud) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_crud = false;
    },

    close_multiTable() {
      if (this.show_multiTable) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_multiTable = false;
    },

    closeAll() {
      this.close_generic_table();
      this.close_crud();
      this.close_multiTable();
    },

    async get_tabelaPrecos() {
      const res = await this.select_all(`${this.baseURl}/api/v1/precario/`);
      this.tabelaPrecos = res;
    },

    async select_tabela_preco(data) {
      this.create_btn = false;
      this.create_tabela_preco_ = false;
      this.form_title = "Informações da tabela de Preço";
      const tabelaPreco = await this.select(
        `${this.baseURl}/api/v1/precario/${data.id}/`
      );
      this.tabelaPreco = JSON.parse(JSON.stringify(tabelaPreco));
      if (tabelaPreco) {
        this.setTabelaPrecoForm(tabelaPreco);
        this.show_form = true;
      }
    },

    async create_tabela_preco(data) {
      let create_data = this.setData(data);
      const res = await this.create(
        create_data,
        `${this.baseURl}/api/v1/precario/registrar/`
      );
      if (res) {
        data.id = res.id;
        toast.success("Tabela de Preço criada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.get_tabelaPrecos();
        this.closeForm();
        this.show_table = true;
      } else {
        toast.error("Erro ao criar tabela de preço", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },

    closeForm() {
      this.show_form = false;
      this.closeAll();
    },
    closeFilterForm() {
      this.show_form_filter = false;
    },

    close_table() {
      this.show_table = false;
    },
    close_generic_table() {
      if (this.show_generic_table || this.show_item_precario_table) {
        //this.show_generic_table=false;
        document.getElementById("right_form").style.display = "flex";
      }

      this.show_item_precario_table = false;
      this.show_generic_table = false;
    },

    triggerAction(action) {
      // console.log("action to perform:", action)
      if (action.action === "create_tabelaPreco") {
        this.create_tabela_preco_ = true;
        this.form_title = "Criar Tabela Preco";
        this.setTabelaPrecoForm(null);

        this.close_generic_table();
        this.create_btn = true;
        this.show_form = true;
      }
      if (action.action === "show_table") {
        this.show_table = true;
      }
      if (action.action === "criar_filtro") {
        this.show_form_filter = true;
      }
    },

    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },

    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },

    setData(data) {
      let prepared_data = {
        nome: data.nome || "",
        versao: data.versao || "",
        data: data.data || "",
        validade: data.validade || "",
        descontoBase: data.descontoBase || 0,
        descontoMax: data.descontoBase || 0,
        valorRapel: data.valorRapel || 0,
        descontoRapel: data.descontoRapel || 0,
        tabela_base: data.tabela_base || 0,
        tpMoeda_id: data.tpMoeda_id || 0,
      };
      return prepared_data;
    },

    show_form_table(data) {
      if (data === "ItemPrecoGeral") {
        document.getElementById("right_form").style.display = "none";
        this.generic_table_title = "Preços Equipamentos";
        this.show_item_precario_table = true;
        this.searchBy = "Equipamentos";
      } else if (data === "ItemPrecoGeralServicos") {
        document.getElementById("right_form").style.display = "none";
        this.generic_table_title = "Preços Serviços";
        this.show_item_precario_table = true;
        this.searchBy = "Serviços";
      } else if (data === "localInstalacao") {
        this.show_multiTable = true;
        document.getElementById("right_form").style.display = "none";
      } else {
        const tableMappings = {
          armazem: { data: this.armazens, title: "Armazens" },
          preços: {
            data: [{ Tarefa: "Ainda não implementada" }],
            title: "Preços",
          },
          produtos: {
            data: [{ Tarefa: "Ainda não implementada" }],
            title: "Produtos",
          },
          faturação: {
            data: [{ Tarefa: "Ainda não implementada" }],
            title: "Faturação",
          },
          orçamentos: {
            data: [{ Tarefa: "Ainda não implementada" }],
            title: "Orçamentos",
          },
          encomenda: {
            data: [{ Tarefa: "Ainda não implementada" }],
            title: "Encomendas",
          },
        };

        const mapping = tableMappings[data];
        if (mapping) {
          this.current_table = data;
          this.generic_table_data = mapping.data;
          this.generic_table_title = mapping.title;
          this.show_generic_table = true;
          document.getElementById("right_form").style.display = "none";
          //document.getElementById('table_container').style.maxHeight='none';
        }
      }
    },

    // BackofficeDataTable event handlers
    handleEditItemPrecario(item) {
      this.item_precario_data = item;
      this.show_item_precario_edit = true;
    },

    handleDeleteItemPrecario(item) {
      console.log("Delete ItemPrecario:", item);
      if (
        confirm(
          `Tem certeza que deseja eliminar o item ${item.equipamento_nome}?`
        )
      ) {
        this.deleteItemPrecarioFromAPI(item.id);
      }
    },

    handleBulkEditItemPrecario(selectedItems) {
      console.log(
        "Bulk Edit ItemPrecario triggered with items:",
        selectedItems
      );
      if (selectedItems.length === 0) {
        toast.warning("Selecione pelo menos um item para editar em lote");
        return;
      }
      this.openBulkEdit(selectedItems);
    },

 

    viewItemPrecarioDetails(item) {
      console.log("View ItemPrecario details:", item);
      // TODO: Open details modal or navigate to details view
      toast.info("Detalhes do ItemPrecario - Em desenvolvimento");
    },

    async deleteItemPrecarioFromAPI(itemId) {
      try {
        const url = `${this.baseURl}/api/v1/itemprecario/${itemId}/?eliminar=true`;
        await this.remove(url);
        toast.success("Item eliminado com sucesso");
        this.refresh = true; // Trigger table refresh
      } catch (error) {
        console.error("Error deleting ItemPrecario:", error);
        toast.error("Erro ao eliminar item");
      }
    },

    // handleFiltersChanged is now handled by ItemPrecarioDataTable component
    handleFiltersChanged(filters, changedFilterKey) {
      // This method can be used if parent needs to respond to filter changes
      console.log(
        "Filters changed in ItemPrecario table:",
        filters,
        changedFilterKey
      );
    },
  },
  watch: {},
  computed: {
    urlString() {
      return "itemprecario";
    },
    is_base_table() {
      return this.tabelaPreco && this.tabelaPreco.tabela_base === 1;
    },
  },
};
</script>

<style>
.scroll-style {
  overflow-y: auto;
  scrollbar-color: gray transparent;
  scrollbar-width: thin;
}
.popup {
  position: fixed;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid black;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.popup-content {
  text-align: center;
}

.popup button {
  margin: 0 10px;
  padding: 5px 10px;
  cursor: pointer;
}
.btn {
  font-size: 12px;
  width: fit-content;
  padding: 0.5rem 0.8rem;
  color: white;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #626288;
}
.btn:hover {
  background-color: #c67700;
}
.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
